import { render } from "./sav-form.vue?vue&type=template&id=7f5844cf"
import script from "./sav-form.vue?vue&type=script&lang=js"
export * from "./sav-form.vue?vue&type=script&lang=js"

import "./sav-form.vue?vue&type=style&index=0&id=7f5844cf&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__